import type { BreadcrumbItem } from '~/types/breadcrumbs'

const breadcrumbsState = () =>
  useState<BreadcrumbItem[]>('breadcrumbs', () => [])

export function setBreadcrumbs(breadcrumbs: MaybeRef<BreadcrumbItem[]>) {
  const state = breadcrumbsState()
  state.value = unref(breadcrumbs)
}

export function getBreadcrumbs() {
  return computed(() => breadcrumbsState().value)
}
